import { stringify } from 'qs'

import { lsGet, safeAwait } from 'utils/request'

export const getAlbums = (props) => {
  return safeAwait(lsGet(`/albums?${stringify(props)}`))
}
